import React, { Component } from "react";
import { Grid, Icon, List } from "semantic-ui-react";
import "../accounting.css";
class AnnualLedger extends Component {
  componentDidMount() {
    this.props.getledger();
  }
  genledger() {
    console.log(this.props.ledgerinfo);
    if (this.props.ledgerinfo !== null) {
      console.log(this.props.ledgerinfo);
      let ledgerinfo = this.props.ledgerinfo;
      return (
        <List horizontal id="ledgerlist">
          <List.Item id="ledgeritem">
            <List.Content>
              <List.Header as="h2">Total Billed</List.Header>
              <div id="ledgerdata">
                <Icon name="dollar" />
                {ledgerinfo.totalbilled}
              </div>
            </List.Content>
          </List.Item>
          <List.Item id="ledgeritem">
            <List.Content>
              <List.Header as="h2">Total Paid</List.Header>
              <div id="ledgerdata">
                <Icon name="dollar" /> {ledgerinfo.totalpaid}
              </div>
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              <List.Header as="h2">Total Outstanding</List.Header>
              <div id="ledgerdata">
                {" "}
                <Icon name="dollar" /> {ledgerinfo.totaloutstanding}
              </div>
            </List.Content>
          </List.Item>
        </List>
      );
    }
  }
  render() {
    return (
      <div className="AnnualLedger">
        <Grid>
          <Grid.Row>{this.genledger()}</Grid.Row>
        </Grid>
      </div>
    );
  }
}
export default AnnualLedger;



// WEBPACK FOOTER //
// ./src/components/accounting/invoices/annualledger.jsx